// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__etFLt","subTitleBold":"BoxSubTitle_subTitleBold__kqvNw"};